module.exports = __webpack_public_path__ + "images/ds-cme-projects.webp";